"use strict";
// tslint:disable
/**
 * Sleekflow General Api
 * Sleekflow General Api
 *
 * The version of the OpenAPI document: api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationApi = void 0;
var runtime_1 = require("../runtime");
/**
 * no description
 */
var ConversationApi = /** @class */ (function (_super) {
    __extends(ConversationApi, _super);
    function ConversationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConversationApi.prototype.conversationAssignConversationIdPost = function (_a, opts) {
        var conversationId = _a.conversationId, travisBackendCompanyDomainViewModelsStaffAssignmentViewModel = _a.travisBackendCompanyDomainViewModelsStaffAssignmentViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(conversationId, 'conversationId', 'conversationAssignConversationIdPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Conversation/Assign/{conversationId}'.replace('{conversationId}', (0, runtime_1.encodeURI)(conversationId)),
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsStaffAssignmentViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.conversationBookmarkConversationIdPost = function (_a, opts) {
        var conversationId = _a.conversationId, bookmark = _a.bookmark;
        (0, runtime_1.throwIfNullOrUndefined)(conversationId, 'conversationId', 'conversationBookmarkConversationIdPost');
        var headers = {};
        var query = {};
        if (bookmark != null) {
            query['bookmark'] = bookmark;
        }
        return this.request({
            url: '/Conversation/Bookmark/{conversationId}'.replace('{conversationId}', (0, runtime_1.encodeURI)(conversationId)),
            method: 'POST',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.conversationConversationIdGet = function (_a, opts) {
        var conversationId = _a.conversationId;
        (0, runtime_1.throwIfNullOrUndefined)(conversationId, 'conversationId', 'conversationConversationIdGet');
        var headers = {};
        return this.request({
            url: '/Conversation/{conversationId}'.replace('{conversationId}', (0, runtime_1.encodeURI)(conversationId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.conversationExportPost = function (_a, opts) {
        var travisBackendMessageDomainViewModelsExportConversationViewModel = _a.travisBackendMessageDomainViewModelsExportConversationViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/conversation/export',
            method: 'POST',
            headers: headers,
            body: travisBackendMessageDomainViewModelsExportConversationViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.conversationMessageConversationIdGet = function (_a, opts) {
        var conversationId = _a.conversationId, offset = _a.offset, limit = _a.limit, beforeMessageId = _a.beforeMessageId, afterMessageId = _a.afterMessageId, afterTimestamp = _a.afterTimestamp, beforeTimestamp = _a.beforeTimestamp, channel = _a.channel, channelIds = _a.channelIds, isFromUser = _a.isFromUser, isFromImport = _a.isFromImport, order = _a.order, isGetFileOnly = _a.isGetFileOnly;
        (0, runtime_1.throwIfNullOrUndefined)(conversationId, 'conversationId', 'conversationMessageConversationIdGet');
        var headers = {};
        var query = {};
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        if (beforeMessageId != null) {
            query['beforeMessageId'] = beforeMessageId;
        }
        if (afterMessageId != null) {
            query['afterMessageId'] = afterMessageId;
        }
        if (afterTimestamp != null) {
            query['afterTimestamp'] = afterTimestamp;
        }
        if (beforeTimestamp != null) {
            query['beforeTimestamp'] = beforeTimestamp;
        }
        if (channel != null) {
            query['channel'] = channel;
        }
        if (channelIds != null) {
            query['channelIds'] = channelIds;
        }
        if (isFromUser != null) {
            query['IsFromUser'] = isFromUser;
        }
        if (isFromImport != null) {
            query['IsFromImport'] = isFromImport;
        }
        if (order != null) {
            query['order'] = order;
        }
        if (isGetFileOnly != null) {
            query['isGetFileOnly'] = isGetFileOnly;
        }
        return this.request({
            url: '/Conversation/Message/{conversationId}'.replace('{conversationId}', (0, runtime_1.encodeURI)(conversationId)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.conversationNoteConversationIdPost = function (_a, opts) {
        var conversationId = _a.conversationId, messageChecksum = _a.messageChecksum, conversationId2 = _a.conversationId2, assigneeId = _a.assigneeId, channel = _a.channel, messageChannel = _a.messageChannel, messageGroupName = _a.messageGroupName, subject = _a.subject, messageType = _a.messageType, messageContent = _a.messageContent, files = _a.files, fileUrls = _a.fileUrls, localTimestamp = _a.localTimestamp;
        (0, runtime_1.throwIfNullOrUndefined)(conversationId, 'conversationId', 'conversationNoteConversationIdPost');
        var headers = {};
        var formData = new FormData();
        if (messageChecksum !== undefined) {
            formData.append('MessageChecksum', messageChecksum);
        }
        if (conversationId2 !== undefined) {
            formData.append('ConversationId', conversationId2);
        }
        if (assigneeId !== undefined) {
            formData.append('AssigneeId', assigneeId);
        }
        if (channel !== undefined) {
            formData.append('Channel', channel);
        }
        if (messageChannel !== undefined) {
            formData.append('MessageChannel', messageChannel);
        }
        if (messageGroupName !== undefined) {
            formData.append('MessageGroupName', messageGroupName);
        }
        if (subject !== undefined) {
            formData.append('Subject', subject);
        }
        if (messageType !== undefined) {
            formData.append('MessageType', messageType);
        }
        if (messageContent !== undefined) {
            formData.append('MessageContent', messageContent);
        }
        if (files !== undefined) {
            files.forEach(function (element) { return formData.append('files', element); });
        }
        if (fileUrls !== undefined) {
            fileUrls.forEach(function (element) { return formData.append('fileUrls', element); });
        }
        if (localTimestamp !== undefined) {
            formData.append('LocalTimestamp', localTimestamp);
        }
        return this.request({
            url: '/Conversation/Note/{conversationId}'.replace('{conversationId}', (0, runtime_1.encodeURI)(conversationId)),
            method: 'POST',
            headers: headers,
            body: formData,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.conversationReadConversationIdPost = function (_a, opts) {
        var conversationId = _a.conversationId;
        (0, runtime_1.throwIfNullOrUndefined)(conversationId, 'conversationId', 'conversationReadConversationIdPost');
        var headers = {};
        return this.request({
            url: '/Conversation/Read/{conversationId}'.replace('{conversationId}', (0, runtime_1.encodeURI)(conversationId)),
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.conversationRemarkConversationIdGet = function (_a, opts) {
        var conversationId = _a.conversationId, offset = _a.offset, limit = _a.limit;
        (0, runtime_1.throwIfNullOrUndefined)(conversationId, 'conversationId', 'conversationRemarkConversationIdGet');
        var headers = {};
        var query = {};
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        return this.request({
            url: '/Conversation/Remark/{conversationId}'.replace('{conversationId}', (0, runtime_1.encodeURI)(conversationId)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.conversationSearchMessageConversationIdGet = function (_a, opts) {
        var conversationId = _a.conversationId, keywords = _a.keywords, offset = _a.offset, limit = _a.limit;
        (0, runtime_1.throwIfNullOrUndefined)(conversationId, 'conversationId', 'conversationSearchMessageConversationIdGet');
        var headers = {};
        var query = {};
        if (keywords != null) {
            query['keywords'] = keywords;
        }
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        return this.request({
            url: '/Conversation/Search/Message/{conversationId}'.replace('{conversationId}', (0, runtime_1.encodeURI)(conversationId)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.conversationStatusConversationIdPost = function (_a, opts) {
        var conversationId = _a.conversationId, travisBackendCompanyDomainViewModelsStatusViewModel = _a.travisBackendCompanyDomainViewModelsStatusViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(conversationId, 'conversationId', 'conversationStatusConversationIdPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Conversation/Status/{conversationId}'.replace('{conversationId}', (0, runtime_1.encodeURI)(conversationId)),
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsStatusViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.conversationTagsAddConversationIdPost = function (_a, opts) {
        var conversationId = _a.conversationId, travisBackendMessageDomainViewModelsConversationHashtagViewModel = _a.travisBackendMessageDomainViewModelsConversationHashtagViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(conversationId, 'conversationId', 'conversationTagsAddConversationIdPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Conversation/Tags/Add/{conversationId}'.replace('{conversationId}', (0, runtime_1.encodeURI)(conversationId)),
            method: 'POST',
            headers: headers,
            body: travisBackendMessageDomainViewModelsConversationHashtagViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.conversationTagsConversationIdPost = function (_a, opts) {
        var conversationId = _a.conversationId, travisBackendMessageDomainViewModelsConversationHashtagViewModel = _a.travisBackendMessageDomainViewModelsConversationHashtagViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(conversationId, 'conversationId', 'conversationTagsConversationIdPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Conversation/Tags/{conversationId}'.replace('{conversationId}', (0, runtime_1.encodeURI)(conversationId)),
            method: 'POST',
            headers: headers,
            body: travisBackendMessageDomainViewModelsConversationHashtagViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.conversationTagsRemoveConversationIdPost = function (_a, opts) {
        var conversationId = _a.conversationId, travisBackendMessageDomainViewModelsConversationHashtagViewModel = _a.travisBackendMessageDomainViewModelsConversationHashtagViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(conversationId, 'conversationId', 'conversationTagsRemoveConversationIdPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Conversation/Tags/Remove/{conversationId}'.replace('{conversationId}', (0, runtime_1.encodeURI)(conversationId)),
            method: 'POST',
            headers: headers,
            body: travisBackendMessageDomainViewModelsConversationHashtagViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.conversationTypingPost = function (_a, opts) {
        var travisBackendMessageDomainViewModelsConversationTypingObject = _a.travisBackendMessageDomainViewModelsConversationTypingObject;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/conversation/typing',
            method: 'POST',
            headers: headers,
            body: travisBackendMessageDomainViewModelsConversationTypingObject,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.conversationUnreadConversationIdPost = function (_a, opts) {
        var conversationId = _a.conversationId;
        (0, runtime_1.throwIfNullOrUndefined)(conversationId, 'conversationId', 'conversationUnreadConversationIdPost');
        var headers = {};
        return this.request({
            url: '/Conversation/Unread/{conversationId}'.replace('{conversationId}', (0, runtime_1.encodeURI)(conversationId)),
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.conversationsAssignedToGet = function (_a, opts) {
        var assignedTo = _a.assignedTo, offset = _a.offset, limit = _a.limit, status = _a.status, channel = _a.channel, afterUpdatedAt = _a.afterUpdatedAt, afterModifiedAt = _a.afterModifiedAt, channelIds = _a.channelIds, tags = _a.tags, teamId = _a.teamId, isTeamUnassigned = _a.isTeamUnassigned, isUnread = _a.isUnread, orderBy = _a.orderBy;
        (0, runtime_1.throwIfNullOrUndefined)(assignedTo, 'assignedTo', 'conversationsAssignedToGet');
        var headers = {};
        var query = {};
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        if (status != null) {
            query['status'] = status;
        }
        if (channel != null) {
            query['channel'] = channel;
        }
        if (afterUpdatedAt != null) {
            query['afterUpdatedAt'] = afterUpdatedAt;
        }
        if (afterModifiedAt != null) {
            query['afterModifiedAt'] = afterModifiedAt;
        }
        if (channelIds != null) {
            query['channelIds'] = channelIds;
        }
        if (tags != null) {
            query['tags'] = tags;
        }
        if (teamId != null) {
            query['teamId'] = teamId;
        }
        if (isTeamUnassigned != null) {
            query['isTeamUnassigned'] = isTeamUnassigned;
        }
        if (isUnread != null) {
            query['isUnread'] = isUnread;
        }
        if (orderBy != null) {
            query['orderBy'] = orderBy;
        }
        return this.request({
            url: '/Conversations/{assignedTo}'.replace('{assignedTo}', (0, runtime_1.encodeURI)(assignedTo)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.patchTelegramConversationMessageChannelIdentityIdPost = function (opts) {
        var headers = {};
        return this.request({
            url: '/patchTelegramConversationMessageChannelIdentityId',
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.patchViberConversationMessageChannelIdentityIdPost = function (opts) {
        var headers = {};
        return this.request({
            url: '/patchViberConversationMessageChannelIdentityId',
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.v2ConversationAssignedToSearchMessageGet = function (_a, opts) {
        var assignedTo = _a.assignedTo, keywords = _a.keywords, offset = _a.offset, limit = _a.limit, status = _a.status, channel = _a.channel, channelIds = _a.channelIds, teamId = _a.teamId;
        (0, runtime_1.throwIfNullOrUndefined)(assignedTo, 'assignedTo', 'v2ConversationAssignedToSearchMessageGet');
        var headers = {};
        var query = {};
        if (keywords != null) {
            query['keywords'] = keywords;
        }
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        if (status != null) {
            query['status'] = status;
        }
        if (channel != null) {
            query['channel'] = channel;
        }
        if (channelIds != null) {
            query['channelIds'] = channelIds;
        }
        if (teamId != null) {
            query['teamId'] = teamId;
        }
        return this.request({
            url: '/v2/Conversation/{assignedTo}/Search/Message'.replace('{assignedTo}', (0, runtime_1.encodeURI)(assignedTo)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.v2ConversationAssigneeConversationIdPost = function (_a, opts) {
        var conversationId = _a.conversationId, travisBackendCompanyDomainViewModelsStaffAssigneeChangeViewModel = _a.travisBackendCompanyDomainViewModelsStaffAssigneeChangeViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(conversationId, 'conversationId', 'v2ConversationAssigneeConversationIdPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/v2/conversation/assignee/{conversationId}'.replace('{conversationId}', (0, runtime_1.encodeURI)(conversationId)),
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsStaffAssigneeChangeViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.v2ConversationCollaboratorConversationIdPost = function (_a, opts) {
        var conversationId = _a.conversationId, travisBackendCompanyDomainViewModelsStaffCollaboratorChangeViewModel = _a.travisBackendCompanyDomainViewModelsStaffCollaboratorChangeViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(conversationId, 'conversationId', 'v2ConversationCollaboratorConversationIdPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/v2/conversation/collaborator/{conversationId}'.replace('{conversationId}', (0, runtime_1.encodeURI)(conversationId)),
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsStaffCollaboratorChangeViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.v2ConversationMessageGet = function (_a, opts) {
        var offset = _a.offset, limit = _a.limit, afterTimestamp = _a.afterTimestamp, beforeTimestamp = _a.beforeTimestamp, channel = _a.channel, channelIds = _a.channelIds, isFromUser = _a.isFromUser;
        var headers = {};
        var query = {};
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        if (afterTimestamp != null) {
            query['afterTimestamp'] = afterTimestamp;
        }
        if (beforeTimestamp != null) {
            query['beforeTimestamp'] = beforeTimestamp;
        }
        if (channel != null) {
            query['channel'] = channel;
        }
        if (channelIds != null) {
            query['channelIds'] = channelIds;
        }
        if (isFromUser != null) {
            query['IsFromUser'] = isFromUser;
        }
        return this.request({
            url: '/v2/Conversation/Message',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.v2ConversationSummaryAssignedToGet = function (_a, opts) {
        var assignedTo = _a.assignedTo, status = _a.status, channel = _a.channel, afterUpdatedAt = _a.afterUpdatedAt, afterModifiedAt = _a.afterModifiedAt, channelIds = _a.channelIds, tags = _a.tags, teamId = _a.teamId, isTeamUnassigned = _a.isTeamUnassigned, isUnread = _a.isUnread;
        (0, runtime_1.throwIfNullOrUndefined)(assignedTo, 'assignedTo', 'v2ConversationSummaryAssignedToGet');
        var headers = {};
        var query = {};
        if (status != null) {
            query['status'] = status;
        }
        if (channel != null) {
            query['channel'] = channel;
        }
        if (afterUpdatedAt != null) {
            query['afterUpdatedAt'] = afterUpdatedAt;
        }
        if (afterModifiedAt != null) {
            query['afterModifiedAt'] = afterModifiedAt;
        }
        if (channelIds != null) {
            query['channelIds'] = channelIds;
        }
        if (tags != null) {
            query['tags'] = tags;
        }
        if (teamId != null) {
            query['teamId'] = teamId;
        }
        if (isTeamUnassigned != null) {
            query['isTeamUnassigned'] = isTeamUnassigned;
        }
        if (isUnread != null) {
            query['isUnread'] = isUnread;
        }
        return this.request({
            url: '/v2/conversation/summary/{assignedTo}'.replace('{assignedTo}', (0, runtime_1.encodeURI)(assignedTo)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.v2ConversationSummaryGet = function (_a, opts) {
        var status = _a.status, channel = _a.channel, afterUpdatedAt = _a.afterUpdatedAt, afterModifiedAt = _a.afterModifiedAt, channelIds = _a.channelIds, tags = _a.tags, teamId = _a.teamId, isTeamUnassigned = _a.isTeamUnassigned, isUnread = _a.isUnread;
        var headers = {};
        var query = {};
        if (status != null) {
            query['status'] = status;
        }
        if (channel != null) {
            query['channel'] = channel;
        }
        if (afterUpdatedAt != null) {
            query['afterUpdatedAt'] = afterUpdatedAt;
        }
        if (afterModifiedAt != null) {
            query['afterModifiedAt'] = afterModifiedAt;
        }
        if (channelIds != null) {
            query['channelIds'] = channelIds;
        }
        if (tags != null) {
            query['tags'] = tags;
        }
        if (teamId != null) {
            query['teamId'] = teamId;
        }
        if (isTeamUnassigned != null) {
            query['isTeamUnassigned'] = isTeamUnassigned;
        }
        if (isUnread != null) {
            query['isUnread'] = isUnread;
        }
        return this.request({
            url: '/v2/conversation/summary',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.v3ConversationAssignedToSearchMessageGet = function (_a, opts) {
        var assignedTo = _a.assignedTo, keywords = _a.keywords, offset = _a.offset, limit = _a.limit, status = _a.status, channel = _a.channel, channelIds = _a.channelIds, teamId = _a.teamId, behaviourVersion = _a.behaviourVersion;
        (0, runtime_1.throwIfNullOrUndefined)(assignedTo, 'assignedTo', 'v3ConversationAssignedToSearchMessageGet');
        var headers = {};
        var query = {};
        if (keywords != null) {
            query['keywords'] = keywords;
        }
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        if (status != null) {
            query['status'] = status;
        }
        if (channel != null) {
            query['channel'] = channel;
        }
        if (channelIds != null) {
            query['channelIds'] = channelIds;
        }
        if (teamId != null) {
            query['teamId'] = teamId;
        }
        if (behaviourVersion != null) {
            query['behaviourVersion'] = behaviourVersion;
        }
        return this.request({
            url: '/v3/Conversation/{assignedTo}/Search/Message'.replace('{assignedTo}', (0, runtime_1.encodeURI)(assignedTo)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.v3ConversationReadConversationIdPost = function (_a, opts) {
        var conversationId = _a.conversationId;
        (0, runtime_1.throwIfNullOrUndefined)(conversationId, 'conversationId', 'v3ConversationReadConversationIdPost');
        var headers = {};
        return this.request({
            url: '/v3/conversation/read/{conversationId}'.replace('{conversationId}', (0, runtime_1.encodeURI)(conversationId)),
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.v3ConversationSummaryAssignedToGet = function (_a, opts) {
        var assignedTo = _a.assignedTo, status = _a.status, channel = _a.channel, afterUpdatedAt = _a.afterUpdatedAt, afterModifiedAt = _a.afterModifiedAt, channelIds = _a.channelIds, tags = _a.tags, teamId = _a.teamId, isTeamUnassigned = _a.isTeamUnassigned, isUnread = _a.isUnread, isCollaborator = _a.isCollaborator, behaviourVersion = _a.behaviourVersion;
        (0, runtime_1.throwIfNullOrUndefined)(assignedTo, 'assignedTo', 'v3ConversationSummaryAssignedToGet');
        var headers = {};
        var query = {};
        if (status != null) {
            query['status'] = status;
        }
        if (channel != null) {
            query['channel'] = channel;
        }
        if (afterUpdatedAt != null) {
            query['afterUpdatedAt'] = afterUpdatedAt;
        }
        if (afterModifiedAt != null) {
            query['afterModifiedAt'] = afterModifiedAt;
        }
        if (channelIds != null) {
            query['channelIds'] = channelIds;
        }
        if (tags != null) {
            query['tags'] = tags;
        }
        if (teamId != null) {
            query['teamId'] = teamId;
        }
        if (isTeamUnassigned != null) {
            query['isTeamUnassigned'] = isTeamUnassigned;
        }
        if (isUnread != null) {
            query['isUnread'] = isUnread;
        }
        if (isCollaborator != null) {
            query['isCollaborator'] = isCollaborator;
        }
        if (behaviourVersion != null) {
            query['behaviourVersion'] = behaviourVersion;
        }
        return this.request({
            url: '/v3/conversation/summary/{assignedTo}'.replace('{assignedTo}', (0, runtime_1.encodeURI)(assignedTo)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.v3ConversationUnreadConversationIdPost = function (_a, opts) {
        var conversationId = _a.conversationId;
        (0, runtime_1.throwIfNullOrUndefined)(conversationId, 'conversationId', 'v3ConversationUnreadConversationIdPost');
        var headers = {};
        return this.request({
            url: '/v3/conversation/unread/{conversationId}'.replace('{conversationId}', (0, runtime_1.encodeURI)(conversationId)),
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.v3ConversationUnreadSummaryGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/v3/conversation/unreadSummary',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ConversationApi.prototype.v3ConversationsAssignedToGet = function (_a, opts) {
        var assignedTo = _a.assignedTo, offset = _a.offset, limit = _a.limit, status = _a.status, channel = _a.channel, afterUpdatedAt = _a.afterUpdatedAt, afterModifiedAt = _a.afterModifiedAt, channelIds = _a.channelIds, tags = _a.tags, teamId = _a.teamId, isTeamUnassigned = _a.isTeamUnassigned, isUnread = _a.isUnread, orderBy = _a.orderBy, isAssigned = _a.isAssigned, isCollaborator = _a.isCollaborator, behaviourVersion = _a.behaviourVersion;
        (0, runtime_1.throwIfNullOrUndefined)(assignedTo, 'assignedTo', 'v3ConversationsAssignedToGet');
        var headers = {};
        var query = {};
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        if (status != null) {
            query['status'] = status;
        }
        if (channel != null) {
            query['channel'] = channel;
        }
        if (afterUpdatedAt != null) {
            query['afterUpdatedAt'] = afterUpdatedAt;
        }
        if (afterModifiedAt != null) {
            query['afterModifiedAt'] = afterModifiedAt;
        }
        if (channelIds != null) {
            query['channelIds'] = channelIds;
        }
        if (tags != null) {
            query['tags'] = tags;
        }
        if (teamId != null) {
            query['teamId'] = teamId;
        }
        if (isTeamUnassigned != null) {
            query['isTeamUnassigned'] = isTeamUnassigned;
        }
        if (isUnread != null) {
            query['isUnread'] = isUnread;
        }
        if (orderBy != null) {
            query['orderBy'] = orderBy;
        }
        if (isAssigned != null) {
            query['isAssigned'] = isAssigned;
        }
        if (isCollaborator != null) {
            query['isCollaborator'] = isCollaborator;
        }
        if (behaviourVersion != null) {
            query['behaviourVersion'] = behaviourVersion;
        }
        return this.request({
            url: '/v3/conversations/{assignedTo}'.replace('{assignedTo}', (0, runtime_1.encodeURI)(assignedTo)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    return ConversationApi;
}(runtime_1.BaseAPI));
exports.ConversationApi = ConversationApi;
